import { render } from "./FaqsList.vue?vue&type=template&id=0b8fb746&scoped=true"
import script from "./FaqsList.vue?vue&type=script&lang=js"
export * from "./FaqsList.vue?vue&type=script&lang=js"

import "./faqs.scss?vue&type=style&index=0&id=0b8fb746&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8fb746"]])

export default __exports__